export default "__VITE_ASSET__DDQOqrjp__"